/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** Zone JS is required by default for Angular itself. */
import 'zone.js';  // Included with Angular CLI.
import 'core-js';

declare global {
  interface Element {
    msMatchesSelector(selectors: string): boolean;
  }
}

if (Element.prototype && !Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (Element.prototype && !Element.prototype.closest) {
  Element.prototype.closest = function(selector) {
    let el = this;
    while (el) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }
  };
}
/***************************************************************************************************
 * APPLICATION IMPORTS
 */
